var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsArray, IsEnum, IsOptional, IsString } from 'class-validator';
import { CustomerChatMessageOption, CustomerChatMessageType, } from '../../../enums/customer-chat';
export class SendCustomerChatMessageDto {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], SendCustomerChatMessageDto.prototype, "text", void 0);
__decorate([
    IsArray(),
    IsEnum(CustomerChatMessageOption, { each: true }),
    __metadata("design:type", Array)
], SendCustomerChatMessageDto.prototype, "options", void 0);
__decorate([
    IsEnum(CustomerChatMessageType),
    IsOptional(),
    __metadata("design:type", String)
], SendCustomerChatMessageDto.prototype, "messageType", void 0);
__decorate([
    IsOptional(),
    __metadata("design:type", Object)
], SendCustomerChatMessageDto.prototype, "data", void 0);
